import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerNutricao'; 
import AboutNutricao from './AboutNutricao';
import Nutricao from './CorpoClinicoNutricaoa';

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutNutricao />
        <Nutricao />
      </div>
    );
  };
  
  export default About;
  